import React from 'react';
import { Gift } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
interface Bonus {
  num: string;
  icon: string;
  title: string;
  desc: string;
  value: string;
}
export function Bonuses() {
  const bonuses: Bonus[] = [{
    num: '1',
    icon: '📋',
    title: 'Plantilla de Planificación Anual Completa',
    desc: 'Organización de todo el año semana a semana. Secuencia de contenidos por tomo. Objetivos claros. Plan listo para copiar y pegar en tu planificación oficial.',
    value: 'USD 12'
  }, {
    num: '2',
    icon: '🎮',
    title: 'Guía de Gamificación — 5 Dinámicas de Grupo',
    desc: 'El Banco del Aula, La Bolsa en Vivo, El Juicio Financiero, Survivor Financiero y El Mercado del Trueque. Dinámicas listas para aplicar sin preparación extra.',
    value: 'USD 15'
  }, {
    num: '3',
    icon: '📊',
    title: 'Banco de Evaluaciones y Rúbricas',
    desc: 'Evaluaciones listas para cada tomo con tres niveles de dificultad. Rúbricas profesionales alineadas a competencias. Nunca más un examen desde cero bajo presión.',
    value: 'USD 10'
  }, {
    num: '4',
    icon: '🚀',
    title: 'Manual de Respuestas para Preguntas Difíciles',
    desc: '¿Qué respondo cuando preguntan por Bitcoin, devaluación, trading o estafas? El manual completo con respuestas listas para las preguntas financieras más difíciles del aula.',
    value: 'USD 9'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-y border-brand-accent/10" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        <div className="text-center mb-5" data-id="element-34">
          <div className="inline-flex items-center justify-center bg-brand-accent text-brand-dark font-black px-4 py-1.5 rounded-full mb-3 text-xs shadow-[0_0_20px_rgba(34,197,94,0.5)] tracking-wider uppercase" data-id="element-35">
            <Gift className="w-4 h-4 mr-2" data-id="element-36" />
            ¡GRATIS POR EL DÍA DE HOY!
          </div>
          <h2 className="text-xl md:text-3xl font-black text-white uppercase tracking-tight" data-id="element-37">
            🎁 BONOS EXCLUSIVOS INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-38">
          {bonuses.map((bonus, i) => <div key={i} onClick={scrollToCompra} className="bg-brand-card rounded-lg p-4 md:p-5 border border-brand-accent/30 hover:border-brand-accent transition-colors shadow-[0_4px_15px_rgba(0,0,0,0.5)] relative overflow-hidden flex flex-col cursor-pointer hover:shadow-[0_4px_25px_rgba(34,197,94,0.25)]" data-id="element-39">
              <div className="absolute top-0 right-0 bg-brand-accent text-brand-dark font-black text-[10px] px-2 py-1 rounded-bl-lg" data-id="element-40">
                BONO {bonus.num}
              </div>
              <div className="flex items-center gap-2 mb-2 mt-2 pr-20" data-id="element-41">
                <span className="text-2xl shrink-0" data-id="element-42">{bonus.icon}</span>
                <h3 className="text-sm md:text-base font-black leading-tight text-white uppercase" data-id="element-43">
                  {bonus.title}
                </h3>
              </div>
              <p className="text-[11px] md:text-sm text-gray-300 leading-relaxed font-bold mb-3" data-id="element-44">
                {bonus.desc}
              </p>
              <div className="mt-auto pt-3 border-t border-white/10 flex items-center justify-between" data-id="element-45">
                <span className="text-gray-500 line-through font-black text-xs" data-id="element-46">
                  Valor: {bonus.value}
                </span>
                <span className="text-brand-accent font-black text-sm md:text-base neon-glow" data-id="element-47">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div onClick={scrollToCompra} className="bg-brand-card rounded-lg p-5 md:p-6 text-center border-2 border-brand-accent max-w-2xl mx-auto shadow-[0_0_25px_rgba(34,197,94,0.25)] cursor-pointer hover:shadow-[0_0_40px_rgba(34,197,94,0.45)] transition-shadow" data-id="element-48">
          <p className="text-xs md:text-sm font-black text-gray-300 uppercase tracking-wider mb-2" data-id="element-49">
            Valor total de los 4 bonos:
          </p>
          <p className="text-2xl md:text-3xl font-black text-gray-500 line-through mb-2" data-id="element-50">
            USD 46
          </p>
          <p className="text-xs md:text-sm font-black text-gray-300 uppercase tracking-wider mb-1" data-id="element-51">
            Hoy te los llevás por:
          </p>
          <p className="text-5xl md:text-6xl font-black text-brand-accent neon-glow mb-2" data-id="element-52">
            USD 0
          </p>
          <p className="text-xs md:text-sm text-yellow-300 font-black uppercase tracking-wide italic" data-id="element-53">
            ✨ Incluidos GRATIS con tu compra ✨
          </p>
        </div>
      </div>
    </section>;
}